export default {
  menuList: [
    {
      name: 'Dashboard',
      displayName: 'menu.dashboard',
      icon: 'fas fa-dashboard',
      route: '/dashboard',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
      ],
    },
    {
      name: 'Account',
      displayName: 'menu.account',
      icon: 'fas fa-dashboard',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
      ],
      child: [
        {
          name: 'Profile',
          displayName: 'menu.profile',
          shortName: 'PF',
          route: '/profile',
          parentName: 'Account',
          allow: [
            'COMPANY',
            'SUBCOMPANY',
            'SUPERADMIN',
            'AGENT',
            'SUBAGENT',
            'ADMIN',
          ],
        },
        {
          name: 'Password',
          displayName: 'menu.password',
          shortName: 'PW',
          route: '/password',
          parentName: 'Account',
          allow: [
            'COMPANY',
            'SUBCOMPANY',
            'SUPERADMIN',
            'AGENT',
            'SUBAGENT',
            'ADMIN',
          ],
        },
      ],
    },
    {
      name: 'Member',
      key: 'member',
      displayName: 'menu.memberManagement',
      icon: 'fas fa-member',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
      ],
      child: [
        {
          name: 'Add Agent',
          displayName: 'menu.addAgent',
          shortName: 'AA',
          route: '/add-agent',
          parentName: 'Member',
          allow: [
            'COMPANY',
            'AGENT',
          ],
          isEditPermKey: 'member',
        },
        {
          name: 'Edit Agent',
          displayName: 'menu.editAgent',
          shortName: 'AA',
          route: '/edit-agent',
          parentName: 'Member',
          allow: [
            'COMPANY',
            'AGENT',
            'SUBAGENT',
            'ADMIN',
          ],
          isEditPermKey: 'member',
          isEdit: true,
        },
        {
          name: 'Add Member',
          displayName: 'menu.addMember',
          shortName: 'AM',
          route: '/add-member',
          parentName: 'Member',
          allow: [
            'AGENT',
            'SUBAGENT',
          ],
          isEditPermKey: 'member',
        },
        {
          name: 'Edit Member',
          displayName: 'menu.editMember',
          shortName: 'AA',
          route: '/edit-member',
          parentName: 'Member',
          allow: [
            'COMPANY',
            'AGENT',
            'SUBAGENT',
          ],
          isEditPermKey: 'member',
          isEdit: true,
        },
        {
          name: 'Downline',
          displayName: 'menu.memberDownlineList',
          shortName: 'DL',
          route: '/downline',
          parentName: 'Member',
          allow: [
            'COMPANY',
            'SUBCOMPANY',
            'SUPERADMIN',
            'AGENT',
            'SUBAGENT',
            'ADMIN',
          ],
        },
        {
          name: 'Add Sub Account',
          displayName: 'menu.addSubAccount',
          shortName: 'ASA',
          route: '/add-subaccount',
          parentName: 'Member',
          allow: [
            'COMPANY',
            'AGENT',
          ],
        },
        {
          name: 'Edit SubAccount',
          displayName: 'menu.editSubAccount',
          shortName: 'AA',
          route: '/edit-subaccount',
          parentName: 'Member',
          allow: [
            'COMPANY',
            'AGENT',
          ],
          isEditPermKey: 'member',
          isEdit: true,
        },
        {
          name: 'Sub Accounts',
          displayName: 'menu.subAccount',
          shortName: 'SA',
          route: '/subaccount',
          parentName: 'Member',
          allow: [
            'COMPANY',
            'AGENT',
          ],
        },
      ],
    },
    {
      name: 'Report',
      key: 'report',
      displayName: 'menu.report',
      icon: 'far fa-report',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
      ],
      child: [
        {
          name: 'W/L Member',
          displayName: 'menu.winloseSimple',
          shortName: 'WL',
          route: '/winlosemember',
          parentName: 'Report',
          allow: [
            'COMPANY',
            'SUBCOMPANY',
            'SUPERADMIN',
            'AGENT',
            'SUBAGENT',
            'ADMIN',
          ],
        },
        {
          name: 'Game Report',
          displayName: 'menu.gameReport',
          shortName: 'GR',
          route: '/gamereport',
          parentName: 'Report',
          allow: [
            'COMPANY',
            'SUBCOMPANY',
            'SUPERADMIN',
          ],
        },
        {
          name: 'Round',
          displayName: 'menu.round',
          shortName: 'RD',
          route: '/round',
          parentName: 'Report',
          allow: [
            'SUPERADMIN',
            'ADMIN',
          ],
        },
      ],
    },
    {
      name: 'Payment',
      key: 'statement',
      displayName: 'menu.payment',
      icon: 'far fa-report',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
      ],
      child: [
        {
          name: 'Deposit Withdraw',
          displayName: 'menu.depositWithdraw',
          shortName: 'DW',
          route: '/deposit-withdraw',
          parentName: 'Payment',
          allow: [
            'COMPANY',
            'SUBCOMPANY',
            'SUPERADMIN',
            'AGENT',
            'SUBAGENT',
            'ADMIN',
          ],
        },
      ],
    },
    {
      name: 'Announcements',
      displayName: 'menu.announce',
      icon: 'far fa-report',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
      ],
      child: [
        {
          name: 'Message',
          displayName: 'menu.message',
          shortName: 'MS',
          route: '/message',
          parentName: 'Announcements',
          allow: [
            'COMPANY',
            'SUBCOMPANY',
            'SUPERADMIN',
          ],
        },
        {
          name: 'Banner',
          displayName: 'menu.banner',
          shortName: 'BN',
          route: '/banner',
          parentName: 'Announcements',
          allow: [
            'COMPANY',
            'SUBCOMPANY',
            'SUPERADMIN',
          ],
        },
      ],
    },
    {
      name: 'User Online',
      key: 'useronline',
      displayName: 'menu.useronline',
      icon: 'fas fa-dashboard',
      route: '/useronline',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'ADMIN',
      ],
    },
    {
      name: 'Suggest',
      key: 'suggestion',
      displayName: 'menu.suggest',
      icon: 'far fa-report',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
      ],
      child: [
        {
          name: 'Suggest Member',
          displayName: 'menu.suggest_member',
          shortName: 'SM',
          route: '/suggest-member',
          parentName: 'Suggest',
          allow: [
            'COMPANY',
            'SUBCOMPANY',
            'SUPERADMIN',
            'AGENT',
            'SUBAGENT',
            'ADMIN',
          ],
        },
      ],
    },
    {
      name: 'API Key',
      key: 'apikey',
      displayName: 'menu.apiKey',
      icon: 'far fa-report',
      allow: [
        'SUPERADMIN',
        'AGENT',
        'SUBAGENT',
        'ADMIN',
        'SUBCOMPANY',
      ],
      child: [
        {
          name: 'Seamless Key',
          displayName: 'menu.seamlessKey',
          shortName: 'SK',
          route: '/seamless-key',
          parentName: 'API Key',
          allow: [
            'SUPERADMIN',
            'AGENT',
            'SUBAGENT',
            'ADMIN',
            'SUBCOMPANY',
          ],
        },
        {
          name: 'Transfer Key',
          displayName: 'menu.transferKey',
          shortName: 'TK',
          route: '/transfer-key',
          parentName: 'API Key',
          allow: [
            'SUPERADMIN',
            'AGENT',
            'SUBAGENT',
            'ADMIN',
            'SUBCOMPANY',
          ],
        },
        {
          name: 'Document Api',
          displayName: 'menu.document',
          shortName: 'DA',
          route: '/document-api',
          parentName: 'Marketing',
          allow: [
            'SUBCOMPANY',
            'SUPERADMIN',
            'SUBAGENT',
            'AGENT',
            'ADMIN',
          ],
        },
      ],
    },
    {
      name: 'Finance',
      displayName: 'menu.Finance',
      icon: 'far fa-report',
      allow: [
        'SUPERADMIN',
        'COMPANY',
        'SUBCOMPANY',
        'ADMIN',
        'AGENT',
        'SUBAGENT',
      ],
      child: [
        {
          name: 'Bank Account',
          displayName: 'menu.bankAccount',
          shortName: 'BA',
          route: '/bank-account',
          parentName: 'Finance',
          allow: [
            'SUPERADMIN',
            'COMPANY',
            'SUBCOMPANY',
          ],
        },
        {
          name: 'USDT Account',
          displayName: 'menu.cryptoAccount',
          shortName: 'BA',
          route: '/usdt-account',
          parentName: 'Finance',
          allow: [
            'SUPERADMIN',
            'COMPANY',
            'SUBCOMPANY',
          ],
        },
        {
          name: 'Invoice',
          displayName: 'menu.invoice',
          shortName: 'IV',
          route: '/invoice',
          parentName: 'Finance',
          allow: [
            'SUPERADMIN',
            'COMPANY',
            'SUBCOMPANY',
          ],
        },
        {
          name: 'Currency',
          displayName: 'menu.currency',
          shortName: 'CY',
          route: '/currency',
          parentName: 'Finance',
          allow: [
            'ADMIN',
            'SUPERADMIN',
            'COMPANY',
            'SUBCOMPANY',
            'AGENT',
            'SUBAGENT',
          ],
        },
      ],
    },
    {
      name: 'ADMIN',
      key: 'admin',
      displayName: 'menu.adminmanagement',
      icon: 'far fa-report',
      allow: [
        'SUPERADMIN',
        'ADMIN',
      ],
      child: [
        {
          name: 'Game Maintenance',
          displayName: 'menu.maintenance',
          shortName: 'GV',
          route: '/game-version',
          parentName: 'ADMIN',
          allow: [
            'SUPERADMIN',
            'ADMIN',
          ],
        },
        {
          name: 'Secure Code',
          displayName: 'menu.securecode',
          shortName: 'SC',
          route: '/secure-code',
          parentName: 'ADMIN',
          allow: [
            'SUPERADMIN',
            'ADMIN',
          ],
        },
        {
          name: 'Reset Password Log',
          displayName: 'menu.resetpasslog',
          shortName: 'RP',
          route: '/reset-passlog',
          parentName: 'ADMIN',
          allow: [
            'SUPERADMIN',
            'ADMIN',
          ],
        },
        {
          name: 'Activity',
          displayName: 'menu.activity',
          shortName: 'AT',
          route: '/activity',
          parentName: 'ADMIN',
          allow: [
            'SUPERADMIN',
            'ADMIN',
          ],
        },
        {
          name: 'CommissionLog',
          displayName: 'menu.commissionlog',
          shortName: 'AT',
          route: '/commission-log',
          parentName: 'ADMIN',
          allow: [
            'SUPERADMIN',
            'ADMIN',
          ],
        },
      ],
    },
    {
      name: 'Marketing',
      displayName: 'menu.marketing',
      icon: 'far fa-report',
      allow: [
        'COMPANY',
        'SUBCOMPANY',
        'SUPERADMIN',
        'SUBAGENT',
        'AGENT',
        'ADMIN',
      ],
      child: [
        {
          name: 'Feature',
          displayName: 'menu.feature',
          shortName: 'ft',
          route: '/feature',
          parentName: 'Marketing',
          allow: [
            'COMPANY',
            'AGENT',
            'SUPERADMIN',
          ],
        },
      ],
    },
  ],
};
